import React from "react";
import { t as i18nT } from "../i18n";


const Footer = () => {
  return (
    <footer className="mt-8 flex items-center justify-between border-t border-[#3c2414] bg-[#070604] p-4">
      <p className="text-sm text-[#f8f2e6]/60">{i18nT("common.yourCompanyAllRightsReserved")}</p>
    </footer>
  );
};

export default Footer;
